import {
  ChangeDetectorRef,
  Component,
  EventEmitter, inject,
  Inject,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { concat, Observable, Subscription } from "rxjs";
import { NotificationService } from "../../../../services/notification.service";
import { fadeIn } from "../../../../shared/animations/basic-animation";
import { User } from "../../../../store/entities/user-management/users/users.model";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SettingsService } from "../../../../services/settings.service";
import { AttachmentService } from "../../../../services/attachment.service";
import { GET_ALL_USER, UPDATE_USER_PROFILE_MUTATION } from "../../../../store/entities/user-management/users/users.graphql";
import { GraphqlService } from "../../../../services/graphql.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UPDATE_USER_MUTATION } from "../../../../store/entities/user-management/users/users.graphql";
import { environment } from '../../../../../environments/environment';
import { UPLOAD_ATTACHMENT } from '../../../../store/entities/shared/attachment.graphql';

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrl: './user-view.component.scss',
  animations: [fadeIn]
})
export class UserViewComponent implements OnInit, OnDestroy {
  userProfile: User;
  isLoading = false;
  form: FormGroup;
  photo: string;
  uploadingImage = false;

  constructor(
    private notificationService: NotificationService,
    private settingsService: SettingsService,
    private attachmentService: AttachmentService,
    private apollo: GraphqlService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { user?: User; uniqueId?: string }
  ) { }

  ngOnInit(): void {
    this.initForm();

    if (this.data.user) {
      this.userProfile = this.data.user;
      this.photo = this.userProfile.photo;
      this.form.patchValue({
          firstName: this.userProfile.firstName,
  lastName: this.userProfile.lastName,
        email: this.userProfile.email,
        phone: this.userProfile.phone,
      });

      if (this.photo) {
        console.log(this.userProfile.photo);
        this.userProfile = {
          ...this.userProfile,
          photo: environment.MEDIA_SERVER_URL + this.userProfile.photo
        }
      }
    } else if (this.data.uniqueId) {
      this.fetchUserById(this.data.uniqueId);
    }
  }

  initForm() {
    this.form = this.fb.group({
          firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
         email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
      phone: ['', [Validators.required]]
    });
  }

  async fetchUserById(uniqueId: string) {
    this.isLoading = true;

    try {
      const result: any = await this.apollo.query({
        query: GET_ALL_USER,
        variables: {
          filtering: { pageNumber: 1, uniqueId }
        },
      });

      const { data, response } = result.data.getAllUsers;

      if (response?.status && data?.length) {
        this.userProfile = data[0];
        this.photo = this.userProfile?.photo;

        this.form.patchValue({
            firstName: this.userProfile.firstName,
           lastName: this.userProfile.lastName,
          email: this.userProfile.email,
          phone: this.userProfile.phone,
        });

        if (this.photo) {
          await this.fetchUserProfile(this.photo);
        }
      } else {
        this.notificationService.errorMessage("User not found.");
      }
    } catch (e) {
      this.notificationService.errorMessage(e.message || 'Failed to fetch user');
    } finally {
      this.isLoading = false;
    }
  }

  async fetchUserProfile(path: string) {
    this.userProfile.photo = environment.MEDIA_SERVER_URL + path
    console.log(this.userProfile.photo);

    // this.isLoading = true;
    // try {
    //   const response = await this.attachmentService.readAttachment(path);
    //   this.userProfile.photo = 'data:image/png;base64,' + response?.base64String;
    // } catch (e) {
    //   this.notificationService.errorMessage(e.message);
    // } finally {
    //   this.isLoading = false;
    // }
  }
async onFileSelected(event: any) {
  event.preventDefault(); // Prevents any form-related defaults
  event.stopPropagation(); // Stops the event from hitting the modal backdrop
  
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = async () => {
    const base64String = (reader.result as string).split(',')[1];
    await this.uploadPhoto(base64String, file.name);
    event.target.value = ''; // Reset so you can upload again if it fails
  };
  reader.readAsDataURL(file);
}

async uploadPhoto(base64String: string, fileName: string) {
  this.uploadingImage = true;
  try {
    const input = { base64String, fileName };

    const result: any = await this.apollo.mutate({
      mutation: UPLOAD_ATTACHMENT,
      variables: { input }
    });


    const uploadData = result?.data?.uploadBase64File;
    if (uploadData?.response?.status) {
  
      const newPath = uploadData.data.filePath; 
      
      this.photo = newPath; 
      this.userProfile.photo = environment.MEDIA_SERVER_URL + newPath;
      

    }
  } catch (e) {
    this.notificationService.errorMessage('Photo upload failed');
  } finally {
    this.uploadingImage = false;

    this.cdr.detectChanges(); 
  }
}

  async updateUserData() {
    if (this.form.invalid) return;

    const input = {
      email: this.form.value.email,
      phone: this.form.value.phone,
      uniqueId: this.userProfile.uniqueId,
      firstName: this.form.value.firstName,
  lastName: this.form.value.lastName,
   photo: this.photo,
      // accountType: this.userProfile.accountType,
      // roleUniqueId: this.userProfile.role.uniqueId,
    };

    try {
      const response = await this.apollo.mutate({
        mutation: UPDATE_USER_PROFILE_MUTATION,
        variables: { input }
      });

      if (response?.data?.updateUserProfileMutation?.response?.status) {
        this.notificationService.successMessage('User updated successfully.');
      } else {
const result = response?.data?.updateUserProfileMutation;

if (result?.response?.status) {
  this.notificationService.successMessage('User updated successfully.');
} else {
  this.notificationService.errorMessage(
    result?.response?.message || 'Update failed.'
  );
}
      }
    } catch (error) {
      this.notificationService.errorMessage(error.message || 'Update failed.');
    }
  }

  downloadUserManual() {
    const url = environment.MEDIA_SERVER_URL + '/documents/user_manual/MSD-WEMIS USER MANUAL-1.pdf';
    fetch(url)
      .then(res => res.blob())
      .then(blob => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'MSD-WEMIS USER MANUAL-1.pdf';
        a.click();
        URL.revokeObjectURL(a.href);
      })
      .catch(() => this.notificationService.errorMessage('Failed to download user manual'));
  }

  closeDialog() {
    this.settingsService.closeDialog(UserViewComponent);
  }

  ngOnDestroy(): void { }
}
